import { InjectionToken } from "@angular/core";


export interface PcpInsightsConfigInterface {
    connectionString: string;
    cloudRoleName: string;
    logNgrxActions: boolean;
    applicationVersion: string;
}
export const PCP_INSIGHTS_CONFIG = new InjectionToken<PcpInsightsConfigInterface>('PcpInsightsConfig');
